// エラー項目をハイライト
BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.input-error'), elem => {
		if (!/[^\s]/.test(elem.textContent)) return
		const group = BS.DOM.closest('.form-group', elem)
		if (!group) return
		group.classList.add('has-error')
	})
})
